export const KwanMobileSecond = () => {
    return (
        <div className="py-[17px] px-[30px] flex flex-col gap-[15px]">
            <div className="flex justify-center"><div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">TIKTOK场景中常见的问题</div></div>



                <Item
                    img="/imgs/kwan/1.png"
                    title="全球办公网络波动大，体验差影响效率"
                />
                <Item img="/imgs/kwan/2.png" title="跨国区域受限制、访问难、易封号" />

                <Item img="/imgs/kwan/3.png" title="自建专线部署价格高、周期长" />
                <Item img="/imgs/kwan/4.png" title="跨运营商穿透难、不稳定" />

                <Item
                    img="/imgs/kwan/5.png"
                    title="业务所需要的网络需求场景多，不灵活"
                />
                <Item img="/imgs/kwan/6.png" title="大量数据传输速度慢，延迟高" />
        </div>
    );
};


export const Item = (props: { img: string; title: string }) => {
    return (
        <div className=" bg-gradient-to-r from-[#EDF9FC] via-[#F1F9FD] to-[#F5F8FF] rounded-[4px] px-[15px] py-[7px] flex items-center">
            <img
                className="w-[22px] min-w-[22px] h-[22px] bg-[#3B77FD] rounded-[4px] mr-[12px]"
                src={props.img}
            />
            <div>
                <div className=" font-normal text-[12px] text-[#000000]">
                    {props.title}
                </div>
            </div>
        </div>
    );
};
